module.exports = __webpack_public_path__ + "d988eb61167ddd62b9647578324fcdc3.svg";